import { createFileRoute } from '@tanstack/react-router';
import { Support } from '@/pages/Support';

/**
 * Support Route - FAQ and Help
 * Authenticated route for support/FAQ content
 */
export const Route = createFileRoute('/_authenticated/support')({
  component: Support,
});
